import { render, staticRenderFns } from "./ModalAlertConfirm.vue?vue&type=template&id=31408df8&scoped=true"
import script from "./ModalAlertConfirm.vue?vue&type=script&lang=js"
export * from "./ModalAlertConfirm.vue?vue&type=script&lang=js"
import style0 from "./ModalAlertConfirm.vue?vue&type=style&index=0&id=31408df8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31408df8",
  null
  
)

export default component.exports